// extracted by mini-css-extract-plugin
module.exports =  {"group":"Q38936mTOK5eX2h45uHC"};